import React, { Component } from "react";
import "moment-timezone";

import DealsService from '../utils/DealsService'

import { Formik, Form } from "formik";
import * as Yup from "yup";
import Alert from 'react-s-alert';

import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";

import { Modal, Button } from 'react-bootstrap'

class AddNoteModal extends Component {
  render() {
    const { showModal, onCloseModal } = this.props
    const validationSchema = Yup.object().shape({
      notes: Yup.string().required("Notes are required").min(15, "minimum 15 characters").max(1000, "maximum 1000 characters")
    });
    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{ notes: '' }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              const { onConfirmModal } = this.props
              const { deal } = this.props
              DealsService.takeAction('add_note', deal.id, values).then(data => {
                Alert.success('Added')
                onConfirmModal(data)
              });
            }}
            render={({
              errors,
              touched,
              isValid,
              isSubmitting,
            }) => (
                <Form>

                  <FormikTextAreaControl fieldLabel='Add Notes' fieldName='notes' errors={errors} touched={touched} textareaHeight={200} />

                  <div style={{ marginTop: 20 }}>
                    <Button onClick={onCloseModal} bsSize='small'>Whoops, cancel this</Button>
                    <Button className='pull-right' disabled={!isValid || isSubmitting} type="submit" bsStyle='success' bsSize='small'>Add a Note</Button>
                  </div>
                </Form>
              )} />
        </Modal.Body>
      </Modal>)
  }
}

export default AddNoteModal